import uuid from 'uuid'
import BlockTypes from '@slite/editor/lib/types/BlockTypes'
import insertNodeAfterBlockWithId from '../utils/insertNodeAfterBlockWithId'

// https://iframely.com/docs/iframely-api
// Let's not unfurl bad iframes
const unfurlRels = ['player', 'thumbnail', 'app', 'image', 'reader', 'survey']

export default function makeIframelyExtractor(apiKey) {
  return async function iframelyExtractor(editor, { url, ref }) {
    const encodedURL = encodeURIComponent(url)
    try {
      const response = await fetch(
        `https://iframe.ly/api/iframely?url=${encodedURL}&api_key=${apiKey}`
      )
      const json = await response.json()

      if (!json.rel) {
        return null
      }
      const supported = unfurlRels.filter(x => json.rel.includes(x)).length > 0

      if (!supported) {
        return null
      }

      const node = {
        object: 'block',
        type: BlockTypes.EMBED,
        data: { id: uuid(), url },
      }
      insertNodeAfterBlockWithId(editor, ref, node)
      return node
    } catch (error) {
      // no big deal, just don't insert anything
      return null
    }
  }
}
